import React from "react";

export default function ComingSoonPage({ title = "Coming Soon" }) {
  return (
    <div className="container-fluid p-4">
      <div className="card shadow-sm">
        <div className="card-body text-center py-5">
          <h3>{title}</h3>
          <p className="text-muted">
            This screen is under development.
          </p>
        </div>
      </div>
    </div>
  );
}